<!-- 
程式：memberAddInFamily.vue
功能：群組歸戶
作者：i9400539 鄧啓擇
完成：2020-08-15
-->
<template>
  <main>
    <section class="search container">
      <div class="row">
        <div class="col-12">
          <h3 class="text-green">
            確認家戶成員
          </h3>
          <div
            class="label"
            style="font-size:18px;font-weight: 600;margin: 17px 0px;"
          >
            請確認成員身份與基本資料
          </div>
        </div>
      </div>
    </section>
    <form class="form">
      <section class="search container">
        <h4 class="mt-4 mb-2">本次將加入的成員</h4>
        <!-- kerry test -->
        <data-table-input
          ref="childRef"
          :table-data="selection"
          :options="tableOption.input"
          @submit="submit"
        />
      </section>
      <section
        class="search container"
        style="padding: 0px 21px;margin-bottom: 130px;"
      >
        <h4 class="mt-4 mb-2">此家戶原本的成員</h4>
        <!-- kerry test -->
        <data-table :table-data="familyResult" :options="tableOption.family" />
      </section>
      <fixed-botton ref="fixedBtn">
        <template slot="@function">
          <button type="button" class="btn btn-default btn-custStyle" @click="goBack()">
            上一頁
          </button>
          <button
            type="button"
            class="btn btn-primary btn-custStyle"
            :disabled="!selection.length"
            @click="add2Family()"
          >
            加入
          </button>
        </template>
      </fixed-botton>
    </form>
    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" :content="maskContent" />
  </main>
</template>

<script>
import DataTable from "./components/DataTable/DataTableScroll";
import DataTableInput from "./components/DataTable/DataTableInputCollapse";
import FixedBotton from "./components/modal/fixedBotton";
import { addMembersToFamily,getFamilyMemberByCsidNo  } from "@/service";
import mvMask from "@/desktop/views/mv/components/mvMask";
import { commonMixin } from "@/mixins/common";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "memberAddInFamily",
  mixins: [commonMixin],
  components: {
    mvMask,
    DataTable,
    DataTableInput,
    FixedBotton
  },
  data() {
    return {
      mvMaskOpen: false, //遮罩
      maskContent: "", //遮罩字樣
      backSelection: [], // 回上一頁
      familyResult: [], // 家戶資訊
      addPageStatus: false,
      scrollMessageLoading: false,
      scrollDataLoading: false,
      tableData: [], // 查詢結果
      remoteDataMsg: "資料讀取中，請稍候...", //讀取訊息
      status: {
        0: "戶長",
        1: "配偶",
        2: "子女",
        3: "父母",
        4: "其他",
        5: "孫子女"
      },
      tableOption: {
        // 輸入型table
        input: {
          color: "green",
          columns: [
            {
              width: 110,
              name: "familyrl",
              label: "身分",
              validate: "familyrl",
              headerWarning: "必填",
              warningText: "身分",
              options: {
                1: "配偶",
                2: "子女",
                3: "父母",
                4: "其他",
                5: "孫子女"
              }
            },
            {
              width: 110,
              name: "name",
              label: "姓名",
              validate: "name",
              headerWarning: "必填",
              warningText: "姓名"
            },
            {
              width: 110,
              name: "sex",
              label: "性別",
              validate: "sex",
              headerWarning: "必填",
              warningText: "性別",
              options: {
                1: "男",
                2: "女"
              }
            },
            {
              width: 80,
              name: "ROCbirthday",
              label: "生日",
              validate: "birthday",
              type: "date",
              headerWarning: "生日或年齡擇一必填",
              warningText: "生日或年齡"
            },
            {
              width: 110,
              name: "age",
              label: "年齡",
              validate: "age",
              warningText: "生日或年齡"
            }
          ]
        },
        // 家戶原始資料table
        family: {
          //相關保單table 參數
          color: "green",
          showAge: true, //顯示年齡在生日下方
          columns: [
            {
              width: 110,
              name: "familyrl",
              label: "身分",
              template: data => {
                return `${this.status[data]}`;
              }
            },
            {
              width: 110,
              name: "name",
              label: "姓名"
            },
            {
              width: 110,
              name: "sex",
              label: "性別",
              template: data => {
                return `${data == 1 ? "男" : "女"}`;
              }
            },
            {
              width: 110,
              name: "birthday",
              label: "生日"
            },
            {
              width: 110,
              name: "age",
              label: "年齡"
            }
          ],
          sorting: false
        }
      }
    };
  },
  created() {
    this.familyResult = this.$route.params.familyResult || [];
    if (!this.familyResult.length) {
      this.$router.push({ name: "allHolder" });
      return;
    }
    this.backSelection = this.$route.params.selection || [];
    this.selection = JSON.parse(JSON.stringify(this.backSelection));
    if (this.selection.length) {
      this.selection.forEach(ele => {
        ele["ROCbirthday"] = ele.birthday ? new Date(ele.birthday) : "";
        ele["familyrl"] = "";
        ele.sex = ele.sex == "1" || ele.sex == "2" ? ele.sex : "";
      });
    }
  },
  mounted() {
    this.tableOption.scrollHeight = $(window).height() - 280 - 70;
    let self = this;
    $(window).bind("orientationchange", function() {
      self.tableOption.scrollHeight = parseInt($(window).height()) - 280 - 70;
    });
  },
  methods: {
    // 上一頁
    goBack() {
      this.$router.push({
        name: "familyAddCust",
        params: {
          selection: this.backSelection,
          familyResult: this.familyResult
        }
      });
    },
    ...mapActions([
      "updateUserItems"
    ]),

    //歸戶
    add2Family() {
      this.$refs.childRef.callValidator();
    },
    //送出
    submit() {
      const agidno = this.$store.state.userInfo.id;
      const headFamilyid = this.$route.params.headFamily.familyid;
      const finalList = this.selection.map(el => {
        return {
          agidno: agidno,
          csidno: el.id || el.ser_no,
          familyrl: el.familyrl,
          name: el.name,
          sex: el.sex,
          birthday: el.ROCbirthday
            ? window.moment(el.ROCbirthday).format("YYYY-MM-DD")
            : "",
          age: el.age
        };
      });


        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen("mvMaskOpen");
        addMembersToFamily(
          agidno,
          headFamilyid,
          finalList
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            getFamilyMemberByCsidNo(agidno, headFamilyid).then(
              (csidresult) => {
                if (csidresult.header && csidresult.data) {
                  var familyLeader = csidresult.data.filter((obj) => {
                    return obj.familyrl === 0;
                  });
                  this.$toast.info({ title: "新增成功" });
                  this.panelClose("mvMaskOpen");
                  this.updateUserItems(familyLeader[0]);
                  localStorage.userItems = JSON.stringify(familyLeader[0]);
                  this.$router.push({ name: "familyRelation" });
                }
              }
            );
          } else {
            this.$toast.info({ title: "新增失敗" });
            this.panelClose("mvMaskOpen");
          }
        });


      // updateCustInFamily(this.$store.state.userInfo.id, finalList).then(
      //   result => {
      //     if (result.header && result.header.status == "200") {
      //       this.$toast.info({ title: result.header.message });
      //       this.$router.push({
      //         name: "familyRelation"
      //       });
      //     } else {
      //       this.$toast.info({ title: result.header.message });
      //     }
      //   }

      // );
    }
  }
};
</script>

<style scoped>
.btn-custStyle {
  padding-top:9px !important;
  width:120px;
  height: 40px;
}
</style>
